import { render, staticRenderFns } from "./Infoadicional.vue?vue&type=template&id=478cb0d2&"
import script from "./Infoadicional.vue?vue&type=script&lang=js&"
export * from "./Infoadicional.vue?vue&type=script&lang=js&"
import style0 from "./Infoadicional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('478cb0d2', component.options)
    } else {
      api.reload('478cb0d2', component.options)
    }
    module.hot.accept("./Infoadicional.vue?vue&type=template&id=478cb0d2&", function () {
      api.rerender('478cb0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/DetailsResidencial/Infoadicional.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/DetailsResidencial/Infoadicional.vue
// module id = gyZk
// module chunks = 0